import { ApiPlatformFilterQueryParamGenerator } from './ApiPlatformFilterQueryParamGenerator';

export const apiFilterQueryParamGenerator = new ApiPlatformFilterQueryParamGenerator();
